import React, { useEffect } from 'react';
import { capitalizeWords } from '@tcp/core/src/utils/utils.js';
import SafeComponent from '@tcp/core/src/components/common/hoc/withErrorBoundary';
import CarouselTab from '../../ModuleTabbedCarousel/molecules/CarouselTab/views/CarouselTab';
import withStyles from '../../../hoc/withStyles';
import AiRecommendationStyle, {
  AiRecommendationsWrapper,
  RecommendationsHeader,
} from '../styles/AiRecommendation.style';

const AiRecommendation = ({
  getRecommendations,
  pageName,
  strategy,
  productId,
  onQuickViewOpenClick,
  serverTime,
  activePromotions,
  headerLabel,
  carouselTabData,
  isAiRecommendationsEnabled,
  engine,
  brand,
  gender,
  className,
  isTransparentImageSizeReduceEnabled,
}) => {
  const { categoriesList } = carouselTabData || {};
  useEffect(() => {
    if (isAiRecommendationsEnabled) {
      getRecommendations({ productId, pageName, strategy, engine, brand, gender });
    }
  }, [productId, pageName, strategy, engine, brand, gender]);

  const headerLabelCapitalized = capitalizeWords(headerLabel || '');

  if (
    !carouselTabData ||
    carouselTabData?.recommendation?.length === 0 ||
    !isAiRecommendationsEnabled
  )
    return null;

  return (
    <AiRecommendationsWrapper className={className}>
      <RecommendationsHeader
        fontSize="fs16"
        component="div"
        fontFamily="secondary"
        fontWeight="bold"
        id="recommendation"
      >
        {headerLabelCapitalized}
      </RecommendationsHeader>
      <div className="visually-similar-carousel">
        <CarouselTab
          variation="ab_test"
          carouselTabData={carouselTabData}
          categoriesList={categoriesList}
          windowSize={[window?.innerWidth] || [1440]}
          onQuickViewOpenClick={onQuickViewOpenClick}
          isRatingViewDisabled={false}
          isTabbedATBDisabled={false}
          isColorSwatchesEnabled={false}
          isDiscountPriceDisabled={false}
          isSimilarProducts={true}
          isPromoMsgEnabledRecommendation={false}
          isUpdatedPromotionsDisplayEnabled={true}
          promotionsData={activePromotions}
          serverTime={serverTime}
          isTransparentImageSizeReduceEnabled={isTransparentImageSizeReduceEnabled}
        />
      </div>
    </AiRecommendationsWrapper>
  );
};

export default SafeComponent(withStyles(AiRecommendation, AiRecommendationStyle));
